import { Component, ViewChild, ElementRef } from '@angular/core';
import { StorageService } from '../../../../services/StorageService';
import { VenueService } from '../../../../services/VenueService';
import { Apiservice } from '../../../../services/ApiService';
import { PermissionsService } from '../../../../services/Permissions';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrl: './scanner.component.scss'
})
export class ScannerComponent {

  Selectedvenue: string = '';
  venueValue: string = '';
  venuelist: any[] = [];
  gate: string = '';
  gatesArray: any = [];
  barcode: string = '';
  barcodeInput: string = '';
  preCheck: string = 'true';
  scanDirection: string = '';
  loading: boolean = false;
  scanDisplayTable: boolean = false;
  loadingText: string = '';
  scanResult: any = [];
  isModalOpen: boolean = false;
  isTicketmaster: boolean = false;
  @ViewChild('dataGrid', { static: false }) dataGrid!: ElementRef;

  constructor(private _http: HttpClient, private storage: StorageService, public venue: VenueService, private apiservice: Apiservice, private permissions: PermissionsService) {
    this.permissions.ticketmaster.subscribe(val => this.isTicketmaster = val);
  }

  getVenueList(){
    this.loading = true;
    this.venue.getVenueList().subscribe((data:any) => {
      this.venuelist = data;
      this.loading = false;
    });
  }

  getGates(event: any) {
    this.apiservice.getGates(this.Selectedvenue).subscribe((result: any) => {
      this.gatesArray = Object.entries(result.gates).map(([key, value]) => ({
        key,
        value,
        
      }));
    });
  }


  onVenueChange(){
    this.storage.saveVenue(this.Selectedvenue);
    const selectedVenueObj = this.venuelist.find(venue => venue.key === this.Selectedvenue);
    this.venueValue = selectedVenueObj ? selectedVenueObj.value: '';
  }

  onGateChange(event: any){
    this.gate = event?.target?.value;
  }

  onBarcodeChange(event: any){
    this.barcode = event.target.value;
    this.barcodeInput = event.target.value;
  }

  selectPreCheckChangeHandler(event: any) {
    if(event.target.checked){
      this.preCheck = "true";
    }
    else{
      this.openModal();
      this.preCheck = "false";
    }
   
  }

  togglePrecheckCheckBox() {
    if (this.preCheck == "true") {
      return  true;
    }
    else {
      return false;
    }

  }

  keepValidation() {
    this.preCheck = "true";
    this.closeModal();
  }

  onDirectionChange(event: any){
    this.scanDirection = event.target.value;
  }

  sendScan() {
    this.scanResult = [];
    this.loading = true
    this.scanDisplayTable = false;
    this.loadingText = 'Loading......'
    const barcodeArray = this.barcodeInput.split('\n');
    this.loading = true
    const body = {
      venue: this.Selectedvenue,
      gate: this.gate,
      barcodes: barcodeArray,
      preCheck: this.preCheck,
      direction: this.scanDirection,
    };
    this._http
      .post(
        'https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/scan',
        body
      )
      .subscribe({
        next: (data) => {
          this.scanResult = data;
          this.loading = false;
          this.scanDisplayTable = true;
        },
      });

   }

   copyTableToClipboard() {
    setTimeout(() => {
      let tableData: string = '';
  
     
      const rows = Array.from(document.querySelectorAll('tm1-data-grid-row'));
  
      if (rows.length === 0) {
        console.warn('No table data found.');
        return;
      }
  
      rows.forEach(row => {
        let rowData: string[] = [];
  
     
        const cells = Array.from(row.querySelectorAll('tm1-data-grid-cell'));
  
        if (cells.length > 0) {
          cells.forEach(cell => {
            rowData.push(cell.textContent?.trim() || '');
          });
  
         
          tableData += rowData.join('\t') + '\n';
        }
      });
  
      if (tableData) {
      
        navigator.clipboard.writeText(tableData).then(() => {
          alert('Table copied to clipboard!');
        }).catch(err => {
          console.error('Failed to copy:', err);
        });
      }
    }, 100); 
  }

  openModal(): void {
    this.isModalOpen = true;
  }

  closeModal(): void {
    this.isModalOpen = false; 
  }
  


ngOnInit(): void {
    const savedVenue = this.storage.getVenue();
    if (savedVenue) {
      this.Selectedvenue = savedVenue;
    }
    this.getGates(this.Selectedvenue);
    this.getVenueList();

}

}
